import React, { useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import styles from '../styles.module.css';

const findLogo = () => {
  let logo;

  const brightLogo = document.querySelector('.brand.bright');
  if (brightLogo) {
    logo = brightLogo.cloneNode(true);
  } else {
    const originalLogo = document.querySelector<HTMLElement>('.logo');
    if (!originalLogo) return null;
    logo = originalLogo.cloneNode(true);
    logo.className = '';

    if (logo.tagName.toLowerCase === 'img') {
      const wrapper = document.createElement('div');
      wrapper.style.background = 'blue';
      wrapper.appendChild(logo);
      logo = wrapper;
    }

    logo.classList.add('brand', 'bright');
    originalLogo.style.visibility = 'hidden';
  }

  logo.classList.add('aha-fullscreen-logo');
  logo.setAttribute('href', '');
  return logo;
};

const Topbar = ({ onClose }: { onClose: () => void }) => {
  const logoRef = useRef(null);
  const windowStyles: React.CSSProperties = {};
  const logoContainerRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (!logoRef.current) {
      logoRef.current = findLogo();
    }

    if (logoRef.current && logoContainerRef.current) {
      logoContainerRef.current.appendChild(logoRef.current);
    }

    const header = document.querySelector('header');
    if (document.body.classList.contains('ideas-portal') && header) {
      windowStyles.backgroundColor =
        window.getComputedStyle(header).backgroundColor;
    }

    return () => {
      const logo = document.querySelector<HTMLElement>('.logo');
      if (logo) {
        logo.style.visibility = 'visible';
      }
    };
  }, [windowStyles]);

  return ReactDOM.createPortal(
    <div
      className={styles.fullscreenTopbar}
      style={windowStyles}
      onClick={onClose}
    >
      <div ref={logoContainerRef} />
      <div className={styles.close}>×</div>
    </div>,
    document.body
  );
};

export default Topbar;
